module.exports = __webpack_public_path__ + "img/new_index_cooperate_bg7.1e819ce7.png";